function manageSwatchElements ()
{
	if (document.getElementsByClassName ("swatch_options")[0])
	{
		let swatch_variant = document.getElementsByClassName ("swatch_options")[0].getElementsByClassName ('swatch-element');
		for (let i = 0; i < swatch_variant.length; i++)
		{
		  swatch_variant[i].addEventListener ('click', e =>
		  {
			document.getElementsByClassName('select-form-variants')[0].getElementsByTagName('option')[i].selected = 'selected';
			if (swatch_variant[i].classList.contains ("soldout"))
			{
			  document.getElementsByClassName ("purchase-details__buttons")[0].style.display = "none";
			} else {
			  document.getElementsByClassName ("purchase-details__buttons")[0].style.display = "flex";
			}
		  });
		}
	}
}

function setScrollPositionVerticalGallery ()
{
    let prod_info_col = document.querySelector (".product__details--product-page");
    if (!prod_info_col) return;
    let prod_info_col_height = prod_info_col.getBoundingClientRect ().height;
    const prod_info_col_pos_y0 = prod_info_col.getBoundingClientRect ().y;
    let prod_info_col_current_pos_y = prod_info_col_pos_y0;

    let gallery_nav = document.querySelector (".gallery-wrap.gallery-thumbnails--left");
    if (!gallery_nav) return;
    let gallery_nav_height = gallery_nav.getBoundingClientRect ().height;
    let gallery_nav_current_pos_y0 = gallery_nav.getBoundingClientRect ().y;
    let gallery_nav_pos_y_target = 0;

    document.addEventListener ("scroll", e =>
    {
        let pos_y_lower_bound = Math.max (window.scrollY - prod_info_col_pos_y0, 0);
        let pos_y_upper_bound = prod_info_col_pos_y0 + prod_info_col_height;
        prod_info_col_current_pos_y = Math.min (pos_y_lower_bound, pos_y_upper_bound);

        gallery_nav_pos_y_target = (prod_info_col_current_pos_y * gallery_nav_height) / prod_info_col_height;
        gallery_nav_pos_y_target = Math.min (gallery_nav_pos_y_target, gallery_nav_current_pos_y0 + gallery_nav_height);

        gallery_nav.scrollTop = gallery_nav_pos_y_target;
    });

    return gallery_nav_pos_y_target;
}

document.addEventListener("DOMContentLoaded", e => 
{
    if (window.innerWidth > 798)
    {
        setScrollPositionVerticalGallery ();
    }
    manageSwatchElements (); 
});

